import LocalPosts from './localPosts'

export default LocalPosts